import { useSelector } from 'react-redux'
import { centsToDollars } from '../../utils/formatters'
import styles from './TaxRules.module.scss'
import { getIsKiosk } from '../../selectors/menus'

const TaxRules = ({ taxRulesBreakdown, rowStyle, totalStyle }) => {
  const isKiosk = useSelector(getIsKiosk)
  if (!taxRulesBreakdown) {
    return null
  }

  return (
    <>
      {Object.values(taxRulesBreakdown).map((taxRule) => (
        <div className={rowStyle} key={taxRule.taxRuleName}>
          <span className={isKiosk && styles.cropTaxRuleName}>{taxRule.taxRuleName}</span>
          <span className={totalStyle}>{centsToDollars(taxRule.taxRuleAmountInCents)}</span>
        </div>
      ))}
    </>
  )
}

export default TaxRules
